import { drawerAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(
  drawerAnatomy.keys
);

const Drawer = defineMultiStyleConfig({
  baseStyle: {
    dialog: {
      background: 'transparent',
      boxShadow: 'none'
    }
  }
});

export default Drawer;
